import { Button } from '@/components/ui/CustomButton';
import type { DialogComponentProps } from '@gokrew/models/dialog';
import { useDialog } from '@gokrew/ui';

export function SessionExpiredDialog({ dialogId }: DialogComponentProps) {
  const { closeDialog } = useDialog();

  const handleRedirect = () => {
    if (dialogId) {
      closeDialog(dialogId);
    }
    window.location.href = '/login';
  };

  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-muted-foreground">
        Your session has expired. Please login again to continue.
      </p>

      <div className="flex justify-end">
        <Button onClick={handleRedirect}>Go to Login</Button>
      </div>
    </div>
  );
}
